/* eslint-disable no-async-promise-executor */
import {baseAPI} from '../utils/CustomAxios';
import {fromCognitoIdentity} from '@aws-sdk/credential-providers';
import {GetObjectCommand, S3Client} from '@aws-sdk/client-s3';
import {getSignedUrl} from '@aws-sdk/s3-request-presigner';
import {IUserInfo} from './Atoms';
import {ICognitoType} from 'interfaces/interface';

/**
 * S3 Cognito 인터페이스
 * @public
 */
interface IS3GetCognito {
  type?: ICognitoType;
  imgUrls: string[];
  uuid: string;
  userInfo: IUserInfo | null;
  isTransactions?: boolean;
}

/**
 * S3 Cognito에서 이미지 URL 가져오기
 * @param params - S3 Cognito 파라미터
 * @returns 이미지 URL 배열
 * @public
 */
export const s3GetCognito = async ({
  type = 'contractors',
  imgUrls,
  uuid,
  userInfo,
  isTransactions,
}: IS3GetCognito) => {
  return new Promise(async function (resolve, reject) {
    try {
      const url = isTransactions
        ? `/v1/create-tong-places-transactions/back-office/access-tokens/cognito`
        : `/v1/${type}/back-office/access-tokens/cognito`;
      const response = await baseAPI.getAxiosInstance().get(url, {
        params: {
          uuid,
        },
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'Access-Control-Allow-Origin': '*',
          Accept: 'application/json',
          authorization: userInfo?.accessToken,
        },
      });
      if (response) {
        const {Region, Bucket, IdentityId, Token} = response.data;

        const logins = {
          'cognito-identity.amazonaws.com': Token,
        };
        const s3 = new S3Client({
          region: Region,
          credentials: fromCognitoIdentity({
            logins,
            clientConfig: {
              region: Region,
              // logger: console,
            },
            identityId: IdentityId,
          }),
        });
        const cogImgUrls: any = [];

        for (const i in imgUrls) {
          if (!imgUrls[i]) {
            cogImgUrls[i] = '';
          } else {
            const Key = decodeURIComponent(
              imgUrls[i].split('amazonaws.com/')[1],
            );

            const getObjectCommend = new GetObjectCommand({
              Bucket: Bucket,
              Key,
            });
            let signedUrl = await getSignedUrl(s3, getObjectCommend);
            cogImgUrls[i] = signedUrl;
          }
        }

        resolve(cogImgUrls);
      }
    } catch (error2) {
      return reject(error2);
    }
  });
};
